if (!customElements.get('load-more-button')) {
  customElements.define(
    'load-more-button',
    class LoadMoreButton extends HTMLElement {
      static buildSectionUrl(nextUrl, sectionId, origin = window.location.origin) {
        const url = new URL(nextUrl, origin);
        url.searchParams.set('section_id', sectionId);
        return url.toString();
      }

      connectedCallback() {
        this.button = this.querySelector('[data-next-url]');
        this.grid = document.getElementById('product-grid');
        if (!this.button || !this.grid) return;

        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      applyPage(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = doc.getElementById('product-grid');
        const items = incomingGrid ? [...incomingGrid.children] : [];

        items.forEach((item) => {
          item.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });
          item.classList.add('scroll-trigger--cancel');
          this.grid.appendChild(item);
        });

        const nextUrl = doc.querySelector('[data-next-url]')?.getAttribute('data-next-url');
        if (nextUrl) {
          this.button.dataset.nextUrl = nextUrl;
          return true;
        }

        this.remove();
        return false;
      }

      async onClick() {
        if (this.loading) return;

        this.loading = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.setAttribute('disabled', '');

        try {
          const response = await fetch(
            LoadMoreButton.buildSectionUrl(this.button.dataset.nextUrl, this.button.dataset.sectionId)
          );
          if (!response.ok) throw new Error(`Load more failed (${response.status})`);
          this.applyPage(await response.text());
        } catch (_error) {
          this.button.removeAttribute('disabled');
        } finally {
          this.loading = false;
          if (this.isConnected) {
            this.button.removeAttribute('aria-busy');
            this.button.removeAttribute('disabled');
          }
        }
      }
    }
  );
}
